import { render } from "./RevenueAnalysis.vue?vue&type=template&id=0c12bb2c&scoped=true"
import script from "./RevenueAnalysis.vue?vue&type=script&lang=js"
export * from "./RevenueAnalysis.vue?vue&type=script&lang=js"

import "./RevenueAnalysis.vue?vue&type=style&index=0&id=0c12bb2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c12bb2c"]])

export default __exports__